import React, { useContext } from "react";
import { useFaqs } from "@queries/useFaqs";
import { ApplicationContext } from "@context/ApplicationContext";
import Loader from "@components/Ui/Loader";
import "./style.scss";

const Faqs = () => {
    const { subscriberGroupId } = useContext(ApplicationContext);
    const { faqs, isLoading } = useFaqs(subscriberGroupId);

    if (isLoading) {
        return <Loader isLoading={isLoading} />;
    }

    return (
        <div className="faqs__wrapper admin-content">
            {faqs ? (
                // eslint-disable-next-line react/no-danger
                <div className="faqs__content" dangerouslySetInnerHTML={{ __html: faqs }} />
            ) : (
                <p className="paragraph">Faq content to follow</p>
            )}
        </div>
    );
};

export default Faqs;
